import React from 'react';
import Icon from '../../../components/AppIcon';

const ReconciliationSummary = ({ stats }) => {
  const variancePercentage = stats?.totalExpected > 0 
    ? ((stats?.totalVariance / stats?.totalExpected) * 100)?.toFixed(2)
    : 0;

  const summaryCards = [
    {
      label: 'Total Drawers',
      value: stats?.totalDrawers,
      icon: 'Wallet',
      color: 'text-blue-500',
      bgColor: 'bg-blue-500/10'
    },
    {
      label: 'Expected Balance',
      value: `$${stats?.totalExpected?.toFixed(2)}`,
      icon: 'DollarSign',
      color: 'text-purple-500',
      bgColor: 'bg-purple-500/10'
    },
    {
      label: 'Actual Balance',
      value: `$${stats?.totalActual?.toFixed(2)}`,
      icon: 'Banknote',
      color: 'text-green-500',
      bgColor: 'bg-green-500/10'
    },
    {
      label: 'Total Variance',
      value: `${stats?.totalVariance >= 0 ? '+' : ''}$${stats?.totalVariance?.toFixed(2)}`,
      icon: 'TrendingUp',
      color: Math.abs(stats?.totalVariance) <= 5 ? 'text-green-500' : 'text-red-500',
      bgColor: Math.abs(stats?.totalVariance) <= 5 ? 'bg-green-500/10' : 'bg-red-500/10',
      subtitle: `${variancePercentage}% variance`
    },
    {
      label: 'Pending Approvals',
      value: stats?.pendingApprovals,
      icon: 'Clock',
      color: 'text-orange-500',
      bgColor: 'bg-orange-500/10'
    },
    {
      label: 'Approved',
      value: stats?.approvedCount,
      icon: 'CheckCircle',
      color: 'text-green-500',
      bgColor: 'bg-green-500/10'
    }
  ];

  return (
    <div className="mb-6">
      <h2 className="text-xl font-bold text-foreground mb-4 flex items-center gap-2">
        <Icon name="BarChart3" size={24} className="text-primary" />
        Daily Summary Dashboard
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
        {summaryCards?.map((card, index) => (
          <div
            key={index}
            className="bg-card rounded-lg shadow-md p-4 border border-border hover:shadow-lg transition-shadow"
          >
            <div className="flex items-start justify-between mb-3">
              <div className={`p-2 rounded-lg ${card?.bgColor}`}>
                <Icon name={card?.icon} size={24} className={card?.color} />
              </div>
            </div>
            <p className="text-sm text-muted-foreground mb-1">{card?.label}</p>
            <p className={`text-2xl font-bold ${card?.color}`}>{card?.value}</p>
            {card?.subtitle && (
              <p className="text-xs text-muted-foreground mt-1">{card?.subtitle}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReconciliationSummary;